<div>
  <p>Sikertelen feltöltés!</p>
  <p>
    A feltölteni kívánt táblázatban nem megfelelően rögzített adatok
    találhatóak. Töltse le az itt megtalálható táblázatotot, az útmutatás
    szerint javítsa az adatokat, majd töltse fel a javított táblázatot.
  </p>
  <div class="flex justify-content-end">
    <button
      class="mr-3 p-button-text"
      (click)="downloadUploadIssues()"
      pButton
      type="button">
      JAVÍTÁSI ÚTMUTATÓ LETÖLTÉSE
    </button>
    <button (click)="ref.close()" class="p-button-text" pButton type="button">
      MÉGSE
    </button>
  </div>
</div>
